import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPhone(phone: string | null): string {
  if (!phone) return "";
  const numbers = phone.replace(/\D/g, "");
  if (numbers.length === 11) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
  }
  if (numbers.length === 10) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
  }
  return phone;
}

/**
 * Converte uma string em um slug URL-friendly
 * - Remove acentos (normaliza para NFD)
 * - Converte para minúsculas
 * - Substitui espaços por traços
 * - Remove caracteres especiais, mantendo apenas [a-z0-9-]
 * - Remove traços no início e fim
 * 
 * @param text - Texto a ser convertido em slug
 * @returns Slug gerado
 * 
 * @example
 * slugify("São Paulo") // "sao-paulo"
 * slugify("Café & Pão") // "cafe-pao"
 * slugify("  Teste   ") // "teste"
 */
export function slugify(text: string): string {
  if (!text) return "";
  
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove acentos
    .replace(/[^a-z0-9]+/g, "-") // Substitui caracteres não alfanuméricos por traço
    .replace(/(^-|-$)/g, ""); // Remove traços no início e fim
}